<template>
  <div class="table__header--no-top-border">
    <AutoComplete
      v-if="props.selectorType === 'autocomplete'"
      v-model="nameFilter"
      force-selection
      :min-length="3"
      :placeholder="props.routeStopLabel"
      option-label="name"
      :suggestions="validRouteStops"
      @clear="clearFilter"
      @complete="({query: name}) => preUpdateRouteStops(name)"
      @item-select="({value: routeStop}) => selectRouteStop(routeStop)"
    />
    <DataTable
      v-if="props.selectorType === 'datatable'"
      v-model:selection="selectedRouteStop"
      :value="validRouteStops"
      selection-mode="single"
      scrollable
      scroll-height="20vh"
      @row-select="addRouteStop"
    >
      <template #header>
        <div class="flex">
          <div class="w-full p-input-icon-right">
            <i class="pi pi-search" />
            <InputText
              id="routeStop-search"
              type="search"
              class="w-11"
              placeholder="Buscar"
              :model-value="nameFilter"
              @update:model-value="preUpdateRouteStops"
            />
          </div>
          <div
            v-if="!props.multiple"
            class="mx-auto"
          >
            <Button
              icon="pi pi-plus"
              :disabled="!selectedRouteStop"
              rounded
              raised
              @click="addRouteStop"
            />
          </div>
        </div>
      </template>
      <Column
        field="name"
        header="Nombre"
        header-class="hidden"
      ></Column>
      <Column
        field="province"
        header="Provincia"
        header-class="hidden"
      ></Column>
      <Column
        field="category"
        header="Tipo"
        header-class="hidden"
      ></Column>
      <Column
        v-if="!props.multiple"
        header="Añadir"
        header-class="hidden"
      >
        <template #body="{data}">
          <Button
            class="mc-row__button-sm"
            icon="pi pi-plus"
            rounded
            raised
            @click="rowAddRouteStop(data)"
          />
        </template>
      </Column>
    </DataTable>
  </div>
</template>

<script setup>
import {ref, computed} from 'vue';
import InputText from 'primevue/inputtext';
import DataTable from 'primevue/datatable';
import AutoComplete from 'primevue/autocomplete';
import Column from 'primevue/column';
import Button from 'primevue/button';
import {searchRouteStop} from '@/api/route-stop/route-stop.api';
// #region Props, Emits
const props = defineProps({
  multiple: {
    type: Boolean,
    default: () => false,
  },
  routeStopLabel: {
    type: String,
    default: () => 'Municipio',
  },
  selectorType: {
    type: String,
    default: () => 'datatable',
  },
});
const emit = defineEmits(['addRouteStop', 'selectRouteStop']);
// #endregion

// #region Params, Ref, Reactives, Computed
const nameFilter = ref('');
const selectedRouteStop = ref(null);
const routeStops = ref([]);
const validRouteStops = computed(() => routeStops.value );
let timeout;
// #endregion

// #region Functions
function clearFilter() {
  nameFilter.value = '';
}
function preUpdateRouteStops(name) {
  if (timeout) {
    clearTimeout(timeout);
  }
  timeout = setTimeout(() => {
    updateRouteStops(name);
  }, 500);
}
async function updateRouteStops(name) {
  let res = [];
  if (name && name.length > 2) {
    res = await searchRouteStop(name);
  }
  routeStops.value = res;
}
function rowAddRouteStop(data) {
  emit('addRouteStop', data);
  selectedRouteStop.value = null;
}
function addRouteStop() {
  emit('addRouteStop', selectedRouteStop.value);
  selectedRouteStop.value = null;
}
function selectRouteStop(selectedRouteStop) {
  emit('selectRouteStop', selectedRouteStop);
}
// #endregion

// #region Effects, Hooks

// #endregion

// #region Provide, Expose
defineExpose({
  clearFilter,
});
// #endregion
</script>

<style lang="scss" scoped>
  .table__header--no-top-border :deep(.p-datatable-header) {
    border: none;
  }
  .table__header--no-top-border :deep(.p-datatable-wrapper) {
    margin-left: 0;
    .p-selectable-row {
      height: 40px !important;
    }
  }
</style>
